import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'//import firebase from '../firebase'
//import firestore from '@firebase/firestore'
import Store from '../store/Store'
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import MergeHelpers from '../helpers/MergeHelpers'
import Vue from 'vue'
import StringHelpers from '../helpers/StringHelpers'
import TablesStore from '../store/CollectionsStore'
// import { innerMode } from 'codemirror'
import Utilities from '../helpers/Utilities'
import Actions from './Actions'
import AlertHelpers from '../helpers/AlertHelpers'
import NumberHelpers from '../helpers/NumberHelpers'

var db = firebase.database()
var fs = firebase.firestore()



export default class {

static getFirestore() {
    return fs
}

static deleteToken() {
    return firebase.firestore.FieldValue.delete()
}

static getId () {
    return fs.collection('teams').doc().id
}    

static getDocumentRef(path) {
    return fs.doc(path)
}

static getTeamRef(team) {
    return fs.collection('teams').doc(team)
}

static getCollectionDocumentRef(team, collection) {
    return this.getTeamRef(team).collection('collections').doc(collection)
}

static getCollectionDataRef(team, collection) {
    return this.getCollectionDocumentRef(team, collection).collection('data')
}

static getCollectionDocumentRefFromPath(path) {
    return fs.collection(path)
}

static getItemRef(item) {
    let ref
    if(item._team && item._collection)
        ref = this.getCollectionDocumentRef(item._team, item._collection).collection('data').doc(item._id)
    else if(item._path)
        ref = fs.collection(item._path).doc(item._id)
    else {
        ref = null
    }
    return ref
}

static getItemTeam(item) {
    if(item._team)
        return item._team
    if(item._path) {
        const pathArr = item._path.split('/')
        if(pathArr[0] == 'teams' && pathArr.length > 1)
            return pathArr[1]
    }
    return null
}

static replaceDataInPath(path, replacement) {
    let arr = path.split('/')
    arr.pop()
    let newPath = arr.join('/') + '/' + replacement
    return newPath
}



//mutates item

static runAction(action, item) {

    let expression = this.merge(action.expression, item)
    let result = ''
    try {
        result = eval(expression)
    } catch (e) {
        result = expression
    }

    console.log('result is ', result)
    let fieldSlug = StringHelpers.toCamelCase(action.field)

    if(action.type == 'Set Field Value') {
        item[fieldSlug] = result
    }

}

static merge(expression, item) {
    let mergeItems = MergeHelpers.findMergeFields(expression)
    
    mergeItems.forEach(mergeItem => {
        let fieldSlug = StringHelpers.toCamelCase(mergeItem)
        let fieldInBrackets = '(\\[' + mergeItem + '\\])'
        let replacement = item[fieldSlug] || ''
        let re = new RegExp(fieldInBrackets, 'gi')
        expression = expression.replace(re, replacement)
    })
    
    return expression
}

static itemCollectionDetails(item) {
    return new Promise( (resolve, reject) => {
                
        resolve('value')
    })
}

static truncateLastSegment(path) {
    const newLength = path.split('/').length - 1
    return this.truncatePath(path, newLength)
}

static truncatePath(path, length) {
    return path.split('/').splice(0, length).join('/')
}

static shortPath(path) {
    const arr = path.split('/')
    let shortArr = arr.filter((x, i) => (i % 2))
    const result = shortArr.join('/')
    return result
}

static async logChanges(changes) {
    
    if(!Object.keys(changes.values).length) {
        console.log('logChanges: No changes made. Logging not needed.')
        return
    }
        

    let log = {...changes}

    const docPath = this.truncatePath(changes.path, 4)
    let ref = fs.doc(docPath)
    let doc = await this.fetchDocument(ref)

    if(doc.logChanges) {
        log._path = this.truncatePath(changes.path, 3) + '/logs/data'
        
        this.saveItem(log)
    }

}

static async saveAndAction(item) { 
    let changes = this.getChanges(item)
    await Actions.runActions(item)
    this.saveItem(item)
    this.logChanges(changes)
}

static firebaseConsolePath() {
    return 'https://console.firebase.google.com/u/0/project/photon-6d209/database/firestore/data'
}

static consoleLogPath(item) {
    console.log(this.firebaseConsolePath() + item._path + '/' + item._id)
}

static openConsole (path) {
    path = this.firebaseConsolePath() + '/' + path
    window.open(path, '_blank')
}

static saveItem(item, options = {merge: true}) { 
    return new Promise( (resolve, reject) => {
        
        let newRecord = false
        if(!item._id) {
            newRecord = true
            item._id = this.getId()
        }

        if(item._new)
            newRecord = true

        let ref = this.getItemRef(item)
        if(!ref) {
            console.log('saveItem: Not saved. Cannot get a ref from this items path', item)
            return
        }
        
        this.addTimestamp(item)
        this.addAuthor(item)
        
        let newItem = this.removeMeta(item)
        this.removeNullsForStorage(newItem)
        this.removeNulls(item)
        
        ref.set(newItem, {merge: options.merge}).then( ()=>{
            console.log('saveItem > success saving ' + (item.name || item._id), this.firebaseConsolePath() + ref.path)
            resolve(item)
        }).catch(err => {
            console.log('saveItem *** FAIL *** ', err)
            console.log(item)
            reject(err)
        })
    })
}

static addTimestamp(item) {
    let ts = firebase.firestore.FieldValue.serverTimestamp()
    if(!item.createdAt)
        item.createdAt = ts
    
    item.updatedAt = ts
}
static addAuthor(item) {
    const myUserId = DataHelpers.getUserId()
    if(!item.createdBy)
        item.createdBy = myUserId
    
    item.updatedBy = myUserId
}

static addOwner(item) {
    const myUserId = DataHelpers.getUserId()
    if(!item.owner)
        item.owner = myUserId
}

static loadOffices(db) {
    let ref = DataHelpers.getRootRef().child('tables/global/offices/data')
    let officesArr = []
    this.streamCollection(ref, officesArr)
}

static fetchCollection(ref) {
    return new Promise( (resolve, reject) => {
        ref.onSnapshot(snap => {
            let arr = []
            snap.storePath = true
            this.snapshotFillArray(snap, arr)
            if(!arr.length) {
                console.log('fetchCollection returned empty array for ref:', ref)
            }
            resolve(arr)
        }, (err) => {
            console.log('Error in fetchCollection:', err.message, 'Trying to load data from', ref.path)
            AlertHelpers.showAlert(err.message)
        })
    })
}

static streamCollection(ref, arr, preferences = {}) {
    return new Promise( (resolve, reject) => {
        
        //prevent huge queries...(jd property is a hack)
        if(!ref.jd.limit)
            ref = ref.limit(10)

        ref.onSnapshot(snap => {
            if(snap.empty) {
                console.log('streamCollection returns empty snapshot')
            }
            snap.storePath = true
            this.snapshotFillArray(snap, arr, preferences)
            resolve(arr)
        }, (err) => {
            Utilities.emptyArray(arr) 
            console.log('Error in streamCollection:', err.message, 'Trying to load data from', ref.path)
            AlertHelpers.showAlert(err.message)
            reject(err.message)
        })
    })
}

static streamDocument(ref, item, preferences = {}) {
    return new Promise( (resolve, reject) => {
        
        Utilities.emptyObject(item)
        ref.onSnapshot(snap => {
            if(!snap.exists)
                return
            const newData = snap.data() || {}
            Utilities.copyProperties(newData, item) //reactive copy
            Vue.set(item, '_id', snap.id)
            Vue.set(item, '_path', snap.ref.path)
            resolve('done')
        }, (err) => {
            item = {} 
            console.log('Error in streamDocument:', err.message, 'Trying to load data from', ref.path)
            AlertHelpers.showAlert(err.message)
            reject(err.message)
        })
    })
}

// ref takes a path that can be a slash separated string, or an object with a team, collection and optional id 

static ref(path) {
    if(Utilities.isObject(path))
        path = this.objectToPath(path)

    if( NumberHelpers.isOdd(path.split('/').length) )
        return fs.collection(path)
    else
        return fs.doc(path)
}

static fetch(ref) {
    const path = ref.path
    if(ref._query || NumberHelpers.isOdd(path.split('/').length))
        return this.fetchCollection(ref)
    else
        return this.fetchDocument(ref)
}

static objectToPath(object) {
    object.team = object.team || 'xxxxxxx'
    if(!object.collection)
        throw('objectToPath > Collection not specified')
    let path = `teams/${object.team}/collections/${object.collection}/data`

    if(object.id)
        path += `/${object.id}`

    return path
}

static fetchDocument(ref) {
    return new Promise( (resolve, reject) => {
        ref.get().then(doc => {
            if(doc.exists) {
                let document = doc.data()
                document = this.convertDates(document)

                Vue.set(document, '_id', doc.id)
                Vue.set(document, '_path', doc.ref.path.replace('/'+doc.id, '') )         
                resolve(document)
            } else {
                resolve(null)
            }
        }, (err) => { 
            console.log('Error in streamDocument:', err.message, 'Trying to load data from', ref.path)
            AlertHelpers.showAlert(err.message)
            reject(err.message)
        })
    })
}

static fetchMulti(refsArray) {
    return new Promise(async (resolve, reject) => {
        const promises = []
        refsArray.forEach(ref => {
            promises.push(this.fetchCollection(ref))
        })
        const results = await Promise.all(promises)
        let mergedItems = []
        results.forEach(arr => {
            mergedItems = DataHelpers.unionById(mergedItems, arr)
        })
        resolve(mergedItems)                         
    })
}

static streamToStore(team, collection, preferences) {
    
    const collectionRef = this.getCollectionDocumentRef(team, collection)

    const p1 = new Promise( (resolve, reject) => {
        let dataRef = collectionRef.collection('data').orderBy('createdAt', 'desc')

        dataRef.onSnapshot( snap => {

            snap.storeTeamAndCollection = true
        
            let data = []
            this.snapshotFillArray(snap, data)
            const count = data.length
            let payload = {
                team, collection, data, count
            }
            
            Store.commit('setCollection', payload)
            resolve(data)
        }, (err) => {
            console.log('Error in streamToStore:', err.message, 'Trying to load data from', dataRef.path)
            AlertHelpers.showAlert(err.message)
        })
    })

    const p2 = new Promise( (resolve, reject) => {
        
        let fieldsRef = collectionRef.collection('fields')

        fieldsRef.onSnapshot(snap => {

            snap.storePath = true
        
            let fields = []
            this.snapshotFillArray(snap, fields)
            let payload = {
                team, collection, fields
            }
            
            Store.commit('setCollection', payload)
            resolve(fields)
        }, (err) => {
            console.log('Error in streamToStore:', err.message, 'Trying to load data from', fieldsRef.path)
            AlertHelpers.showAlert(err.message)
        })
    })

    const p3 = new Promise( (resolve, reject) => {
        
        let actionRef = collectionRef.collection('actions')

        actionRef.onSnapshot(snap => {
        
            let actions = []
            this.snapshotFillArray(snap, actions)
            let payload = {
                team, collection, actions
            }
            
            Store.commit('setCollection', payload)
            resolve(actions)
        }, (err) => {
            console.log('Error in streamToStore:', err.message, 'Trying to load data from', actionRef.path)
            AlertHelpers.showAlert(err.message)
        })
    })
}

static snapshotFillArray(snap, arr, preferences = {}) {
    if(!arr)
        debugger

    let ordered = false

    //empty it first...
    if(!preferences.keepArray) {
        for(let i = arr.length; i > 0; i--) {
            arr.pop()
        }
    }
    
    snap.forEach(docSnapshot => {
        let item = docSnapshot.data()
        item._id = docSnapshot.id

        if(snap.storePath)
            item._path = this.truncateLastSegment(docSnapshot.ref.path)
        
        if(snap.storeTeamAndCollection) {
            const pathArray = docSnapshot.ref.path.split('/')
            item._team = pathArray[1]
            item._collection = pathArray[3]
        }
        
        if(item.order)
            ordered = true

        if(preferences.reverse)
            arr.unshift(item)
        else
            arr.push(item)
    })   

    if(ordered)
        arr = arr.sort(OrderHelpers.sortByOrder)
}   

static deleteItem(item) {
    let ref = this.getItemRef(item)
    ref.delete().then( () => {
        console.log('Firestore > deleteItem: deleted at', ref.path)
    })
}

static removeMeta(obj) {
    let newObj = Object.assign({}, obj)
    for(let prop in newObj) {
        if(prop.substr(0,1) == '_')
            delete newObj[prop]
    }
    return newObj
}

//Convert timestamps to dates recursively...

static convertDates(firebaseObject) {
    
    if (!firebaseObject) return null

    for (const [key, value] of Object.entries(firebaseObject)) {

      // covert items inside array
      if (value && Array.isArray(value) )
        firebaseObject[key] = value.map(item => this.convertDates(item))

      // convert inner objects
      if (value && typeof value === 'object' ){
        firebaseObject[key] = this.convertDates(value)
      }

      // convert simple properties
      if (value && value.toDate) {
          firebaseObject[key] = value.toDate()
      }
    }
    return firebaseObject
}

static removeNullsForStorage(obj) {
    for(let prop in obj) {
        if(obj[prop] === null)
            obj[prop] = this.deleteToken()
    }
}

static removeNulls(obj) {
    for(let prop in obj) {
        if(obj[prop] === null)
            delete obj[prop]
    }
}

static cloneForEdit(obj) {
    let newObj = Object.assign({}, obj)
    const originalObj = this.removeMeta(obj)
    newObj._originalValues = originalObj
    return newObj
}

static getChanges(oldObj, newObj) {
    const oldValues = this.removeMeta(oldObj)
    const newValues = this.removeMeta(newObj)
    let result = {values: {}, changes: [], description: '', hasChanges: false}
    for(let field in newValues) {
        const oldValue = oldValues[field]
        const newValue = newValues[field]

        if(oldValue != newValue) {
            result.hasChanges = true
            result.name = item.name || item.text || item._id
            result.id = item._id
            result.values[field] = newValue
            //prevent undefined in changes...
            const oldValueToSave = this.noUndefined(oldValue)
            result.changes.push({ field, oldValue: oldValueToSave, newValue })
            //result.description += `'${field}' changed from '${oldValue.toString()}' to '${newValue.toString()}'. `
            result.description += this.describeChange(field, oldValue, newValue)           
            result.path = item._path
            result.uid = DataHelpers.getUserId()
        }
    }
    return result
}

static noUndefined(val) {
    if(typeof val == 'undefined')
        return '[empty]'
    return val
}

static describeChange(field, oldValue, newValue) {
    let o = oldValue
    let n = newValue
    if(Utilities.isObject(o))
        o = JSON.stringify(o)
    if(Utilities.isObject(n))
        n = JSON.stringify(n)
    return `'${field}' changed from '${o}' to '${n}'. `
}

static deleteObjectFromArray(obj, arr) {
    //Utilities.log('ListHelpers > delete')

    let idx = arr.findIndex(o => o._id == obj._id )
    if(idx >= 0)
        arr.splice(idx, 1)
    else
        Utilities.log('Firestore > deleteObjectFromArray > Cant find object', obj)
}



/* Older Stuff */



static fetchValue (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let result = snap.val()
            resolve(result)
        })
    })       
}

static fetchItemByName (baseRef, name) {
    return new Promise((resolve, reject) => {
        baseRef.orderByChild('name').equalTo(name).once('value', (snap) => {
            let objects = this.arrayFromSnapshot(snap)
            if(objects && objects.length)
                resolve(objects[0])
            else
                resolve(null)
        })
    })       
}

static objectFromSnapshot(snap) {
    let item = snap.val()
    if(!item)
        return null
    item.meta = {}
    item.meta.id = snap.id
    let pathArray = [...snap.ref.path.pieces_]
    if(pathArray.length > 2 && pathArray[0] == 'tenants')
        item.meta.tenantKey = pathArray[1]
        
    pathArray.pop()
    item.meta.path = pathArray.join('/')  
    return item  
} 

static safelyGetTenant(obj) {
    if(obj && obj.meta && obj.meta.tenantKey)
        return obj.meta.tenantKey
    else
        return Store.getters.tenantKey
}


static fetchItems(ref, storeName, localVariable) {
    if(Store.state[storeName].length) {
        console.log('fetchItems from cache', storeName)
        localVariable = Store.state[storeName]
        return
    }
    this.fetchItemsFromFirebase(ref).then(items => {
        console.log('fetchItems from db', storeName)

        let payload = {
            name: storeName,
            data: items,
        }
        Store.commit('saveItems', payload)
        localVariable = items
    })
}

static saveFieldToFirebase(ref, x) {
    //todo...  
}

static firebaseRefToPath(ref) {
    let refStr = ref.toString()
    let refArr = refStr.split(/\//).slice(3).join('/')
    return refArr
}

static firebaseRefToKey(ref) {
    let pathArray = [...ref.path.pieces_]
    pathArray.pop()
    return pathArray.join("/")
}  

static defaultValue(field) {
    if(field == '[tenantKey]')
        return DataHelpers.getTenantKey()
    if(field == '[stamp]')
        return DataHelpers.getStamp()
    
}





static saveField(ref, value) {
    ref.set(value)
}

//Copy list from one path to another with new keys...

static copyItems(fromRef, toRef) {
    let toPath = this.firebaseRefToPath(toRef)
    this.fetchItemsFromFirebase(fromRef).then(fromItems => {
        fromItems.forEach(item => {
            item.meta.path = toPath
            this.saveItem(item)
        })
        console.log('copyItems reports ' + fromItems.length + ' items copied from ' + this.firebaseRefToPath(fromRef) + ' to ' + toPath + '.')
    })
}

//Copy item from one path to another (id must be included in path)

static copySingleItem(fromRef, toRef) {
    let toPath = this.firebaseRefToPath(toRef)
    let toKey = this.firebaseRefToKey(toRef)
    this.fetchItemSingle(fromRef).then(fromItem => {
        fromItem.meta.path = toPath
        fromItem.meta.id = toKey
        this.saveItem(item)
        console.log('copySingleItem copied from ' + this.firebaseRefToPath(fromItemRef) + ' to ' + toPath + '.', fromItem)
    })
}


} // end class


// WEBPACK FOOTER //
// ./src/data/Firestore.js